/** Plot only: the 27th leaves at least a day (Feb 28) before a forecast on the next 1st. */
export const toMonthEnd = (date: string | number) =>
  typeof date === "string" ? date.replace(/-01$/, "-27") : date;

/**
 * Whether Total Rate vs Date draws its history on month-end dates: the gap join is on and the
 * axis is monthly (every date a 1st). Read from the dates drawn, not the time-step feature,
 * which callers don't pass. Daily and Hybrid keep their dates. (EVA-389)
 */
export const isMonthEndHistoryAxis = (
  axisDates: (string | number)[],
  gapJoinEnabled: boolean
): boolean =>
  gapJoinEnabled &&
  axisDates.every((date) => typeof date === "string" && date.endsWith("-01"));

/** The dates history points are drawn on, for the axis dates and the month-end decision. */
export const historyAxisDates = (
  axisDates: (string | number)[],
  monthEnd: boolean
): (string | number)[] => (monthEnd ? axisDates.map(toMonthEnd) : axisDates);
